import React from 'react';
import { LayoutStyle, BodyStyle } from '../../styles';

const Layout = props => {
    return (
    <LayoutStyle>
        {/* <BodyStyle> */}
        {props.children}
        {/* </BodyStyle> */}
        {/* footer */}
    </LayoutStyle>
    );
}

export default Layout;
